import { Box, Modal } from '@mui/material'
import React from 'react'
import { boxStyle } from '../../../../constants/types'

import { ReactComponent as SleepTime } from '../../../../assets/svgs/rest-time-white.svg'

import GenericTable from '../../../../components/generic-table/generic-table'
import { sleepDetectionText } from './index'

export default function SleepDetectionModal({
	selectedWorkSleepDetection,
	onClose,
	open,
}) {
	const { name } = selectedWorkSleepDetection
	const tableColumns = [
		{
			label: 'Timestamp',
			field: 'timestamp',
			align: 'left',
		},
		{
			label: 'Duration',
			field: 'duration',
			align: 'left',
			cellComponent: ({ data }) => {
				return <span>{data}</span>
			},
		},
	]

	const tableData = [
		{
			timestamp: '2023-06-03T10:15:00Z',
			duration: '5 minutes',
		},
		{
			timestamp: '2023-06-03T10:15:00Z',
			duration: '5 minutes',
		},
		{
			timestamp: '2023-06-03T10:15:00Z',
			duration: '5 minutes',
		},
		{
			timestamp: '2023-06-03T10:15:00Z',
			duration: '5 minutes',
		},
	]

	return (
		<Modal
			open={open}
			onClose={onClose}
			className="class-modal"
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
		>
			<Box
				sx={{ ...boxStyle, width: 450 }}
				className="outline-none px-024 pb-024"
			>
				<div className="flex items-center gap-3 py-6">
					<div className="bg-[#F9F5FF] rounded-full p-2">
						<div className="bg-[#240B3B] rounded-full p-3">
							<SleepTime />
						</div>
					</div>
					<span className="text-20 font-semibold text-black1">
						{`${name} ${sleepDetectionText('sleeping_instances')}`}
					</span>
				</div>

				<div className="w-full">
					<GenericTable
						columns={tableColumns}
						data={tableData}
						className="!px-[0px] !py-[0px] !pb-[25px] overflow-x-auto"
					/>
				</div>
				<div className="flex flex-row justify-between space-x-4 h-[48px] mt-9">
					<button
						className="border border-gray6 rounded-md font-bold bg-white grow h-full flex justify-center items-center text-cyan1"
						onClick={onClose}
					>
						{sleepDetectionText('close_sleeping_instances')}
					</button>
				</div>
			</Box>
		</Modal>
	)
}
